import React from "react";
import "../../stylesheets/privacyPolicy.css";

const TermsAndConditions: React.FC = () => {
  return (
    <div className="privacy-policy">
      <h2 className="centered-heading">Términos y condiciones</h2>

      <h3 className="heading-three">Última actualización: 1 Noviembre 2024</h3>

      <p className="p-color">
        Bienvenido a Lexik.app, una plataforma diseñada para ayudar a los
        usuarios a aprender gramática alemana de forma innovadora. Al utilizar
        nuestra pre-landing page, accedes y aceptas los presentes Términos y
        Condiciones de Uso, que tienen como objetivo regular tu interacción con
        este sitio web. Por favor, léelos atentamente. Si no estás de acuerdo
        con estos términos, te pedimos que no utilices nuestra pre-landing page.
      </p>
      <ol>
        <li>
          <b>Aceptación de los Términos</b>
          <p className="p-color">
            Al acceder y utilizar el sitio web de Lexik.app, confirmas que has
            leído, entendido y aceptado estos Términos y Condiciones, así como
            nuestra Política de Privacidad. Nos reservamos el derecho de
            modificar estos términos en cualquier momento. Las modificaciones se
            publicarán en esta página y serán efectivas inmediatamente después
            de su publicación. Es tu responsabilidad revisar estos términos
            periódicamente.
          </p>
        </li>
        <li>
          <b>Uso del Sitio Web</b>
          <p className="p-color">
            El uso de nuestra pre-landing page está destinado exclusivamente a
            fines informativos y promocionales relacionados con el
            pre-lanzamiento de la aplicación Lexik.app. Al utilizar este sitio,
            te comprometes a:
          </p>
          <ol>
            <li>
              <p className="p-color">
                No utilizar el sitio para ningún propósito ilegal o prohibido
                por estos Términos y Condiciones.
              </p>
            </li>
            <li>
              <p className="p-color">
                No intentar obtener acceso no autorizado a ninguna parte del
                sitio web.
              </p>
            </li>
            <li>
              <p className="p-color">
                No copiar, distribuir, modificar o hacer uso indebido del
                contenido del sitio sin nuestro consentimiento expreso.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <b>Propiedad Intelectual</b>
          <p className="p-color">
            Todos los derechos de propiedad intelectual, incluidos, entre otros,
            textos, gráficos, logos, imágenes, diseño del sitio, funcionalidades
            y contenido de Lexik.app son propiedad exclusiva de Lexik.app o
            están licenciados a la misma. Está estrictamente prohibido copiar,
            reproducir, distribuir o crear obras derivadas de cualquier material
            disponible en este sitio sin la autorización previa por escrito de
            <b>Lexik.app.</b>
          </p>
        </li>

        <li>
          <b>Registro y Lista de Espera</b>
          <p className="p-color">
            Al registrarte en nuestra lista de espera para recibir información
            sobre el lanzamiento de Lexik.app, aceptas proporcionarnos
            información precisa y actualizada, incluido tu nombre y correo
            electrónico. También aceptas que podemos usar tu dirección de correo
            electrónico para enviarte notificaciones sobre nuestro producto,
            actualizaciones, promociones, y otras comunicaciones relacionadas
            con el lanzamiento de la app. Puedes optar por no recibir más
            correos electrónicos en cualquier momento siguiendo las
            instrucciones para cancelar la suscripción que se encuentran en los
            mensajes que te enviemos o contactándonos directamente en
            <b>[legal@lexik.app].</b>
          </p>
        </li>

        <li>
          <b>Limitación de Responsabilidad</b>
          <p className="p-color">
            <b>Lexik.app</b> no se responsabiliza por los siguientes aspectos:
          </p>
          <ol>
            <li>
              <b>Errores o Interrupciones:</b>
              <p className="p-color">
                No garantizamos que el sitio esté libre de errores o que su
                funcionamiento sea ininterrumpido. Aunque hacemos nuestro mejor
                esfuerzo para mantener el sitio operativo, no nos hacemos
                responsables por cualquier interrupción temporal del servicio.
              </p>
            </li>
            <li>
              <b>Precisión del Contenido:</b>
              <p className="p-color">
                El contenido proporcionado en la pre-landing page es de carácter
                informativo y preliminar, y no garantizamos su exactitud,
                integridad o actualidad. Las características mencionadas pueden
                cambiar en la versión final de la app.
              </p>
            </li>
            <li>
              <b>Exclusión de Garantías:</b>
              <p className="p-color">
                Este sitio se proporciona "tal cual" y no ofrecemos garantías
                explícitas o implícitas con respecto al funcionamiento del sitio
                o el contenido disponible en él.
              </p>
            </li>
          </ol>
        </li>

        <li>
          <b>Enlaces a Sitios de Terceros</b>
          <p className="p-color">
            Nuestra pre-landing page puede contener enlaces a sitios web de
            terceros. Estos enlaces se proporcionan para tu conveniencia, pero
            Lexik.app no tiene control sobre el contenido o las políticas de
            privacidad de estos sitios, y no asumimos ninguna responsabilidad
            por ellos. Te recomendamos leer los términos y condiciones de
            cualquier sitio de terceros que visites.
          </p>
        </li>
        <li>
          <b>Privacidad y Protección de Datos</b>
          <p className="p-color">
            La recopilación y el uso de tus datos personales están sujetos a
            nuestra Política de Privacidad, que puedes consultar en [enlace a la
            política de privacidad]. Al aceptar estos términos, también aceptas
            los términos descritos en la política de privacidad.
          </p>
        </li>

        <li>
          <b>Terminación del Acceso</b>
          <p className="p-color">
            Podemos suspender o cancelar tu acceso al sitio en cualquier momento
            y por cualquier motivo, incluyendo, entre otros, el incumplimiento
            de estos Términos y Condiciones. En caso de suspensión o
            cancelación, cesará inmediatamente tu derecho a utilizar el sitio, y
            Lexik.app se reserva el derecho de tomar cualquier acción adicional
            que considere necesaria.
          </p>
        </li>

        <li>
          <b>Ley Aplicable y Jurisdicción</b>
          <p className="p-color">
            Estos Términos y Condiciones se regirán e interpretarán de acuerdo
            con las leyes de [jurisdicción aplicable, como el país o estado
            donde se encuentre registrada Lexik.app]. Cualquier controversia que
            surja en relación con estos términos será resuelta exclusivamente en
            los tribunales competentes de dicha jurisdicción.
          </p>
        </li>

        <li>
          <b>Cambios a los Términos de Uso</b>
          <p className="p-color">
            Nos reservamos el derecho de modificar estos Términos y Condiciones
            en cualquier momento. Te notificaremos cualquier cambio importante
            mediante un aviso en nuestra pre-landing page o por correo
            electrónico. Los cambios serán efectivos a partir de la fecha de
            publicación. Si continúas utilizando el sitio después de que se
            realicen los cambios, se considerará que aceptas los términos
            modificados.
          </p>
        </li>

        <li>
          <b>Contacto</b>
          <p className="p-color">
            Si tienes alguna pregunta o inquietud sobre esta Política de
            Privacidad o nuestras prácticas de privacidad, puedes contactarnos
            en:
          </p>
        </li>
      </ol>
      <div className="contact-info">
        <b>
          Correo electrónico:{" "}
          <a href="mailto:legal@lexik.app"> legal@lexik.app </a>
        </b>
      </div>
    </div>
  );
};

export default TermsAndConditions;
